import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalTaxFilterProps {}

const ModalTaxFilter = ({}: ModalTaxFilterProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;

  const isOpen = getModal('single.filterTax');

  const onClose = () => {
    closeSingleModal('filterTax');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de taxas'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Export.Tax.Filter />
    </Modal>
  );
};

export default ModalTaxFilter;
